import clsx from 'clsx';

import { Text } from '@/components/text';

import type { HintMessageProps } from './message.types';

const HintMessage = ({
  id,
  children,
  limit,
  numberOfCharacters = 0,
  disabled,
}: HintMessageProps) => (
  <div className="flex justify-between">
    <Text
      id={id}
      variant="body3"
      as="span"
      className={clsx([disabled ? 'text-gray-200' : 'text-gray-500'])}
    >
      {children}
    </Text>

    {limit ? <Text
        variant="body3"
        as="span"
        className={clsx([disabled ? 'text-gray-200' : 'text-gray-500'])}
      >
        {numberOfCharacters}/{limit}
      </Text> : null}
  </div>
);

export default HintMessage;
